import {
  Component,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
} from '@angular/core';
import { HOME_DATA } from './home.data';
import { CommonModule } from '@angular/common';
import {
  TranslateModule,
  TranslateService,
  TranslatePipe,
} from '@ngx-translate/core';
import { CarouselComponent } from '../../../Components/carousel/carousel.component';
import { PhotoGalleryComponent } from '../../../Components/photogallery/photogallery.component';
import { TestimonialComponent } from '../../../Components/testimonial/testimonial.component';
import { ITestimonial } from '../../../Components/testimonial/testimonial.model';
import { PopupComponent } from '../../../Components/popup/popup.component';
import { MatDialog } from '@angular/material/dialog';
import { BaseComponent } from '../../base.component';
import { AutoUnsubscribe } from '../../../Services/autoUnsubscribe.service';
import { SchoolApiService } from '../../../Services/schoolApi.service';
import { DOMAIN_TYPE, NATIONAL_PAGES, SCHEMA_TYPE } from '../../../constants';
import { IResponse } from '../../../Models/response.model';
import { IList } from '../../../Models/list.model';
import { ISchoolArticle } from '../../../Models/schoolArticle.model';
import { IPhotoGallery } from '../../../Components/photogallery/photogallery.model';

@AutoUnsubscribe()
@Component({
  selector: 'app-home',
  standalone: true,
  imports: [
    CommonModule,
    TranslateModule,
    CarouselComponent,
    PhotoGalleryComponent,
    TestimonialComponent,
    PopupComponent,
  ],
  providers: [TranslateService, TranslatePipe, SchoolApiService],
  templateUrl: './home.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HomeComponent extends BaseComponent {
  public DATA = HOME_DATA;

  public newsCarousel: ISchoolArticle[] = [];

  public start: number = 0;
  public limit: number = Number.MAX_SAFE_INTEGER;
  public totalcount: number;
  public testimonialData: ITestimonial[];
  public galleryData: IPhotoGallery[];

  constructor(
    override readonly schoolApiService: SchoolApiService,
    private dialog: MatDialog,
    readonly cdr: ChangeDetectorRef,
  ) {
    super(schoolApiService);
    this.domainType = DOMAIN_TYPE.NATIONAL;
  }

  ngOnInit(): void {
    this.getOnHomeNews();
    this.getTestimonials();
    this.getPhotoGallery();
  }

  openIsoArticle(data: any) {
    this.dialog.open(PopupComponent, {
      data,
      maxWidth: '80%',
      height: '75%', // Set the desired height
      position: { top: '10%', left: '27%' },
    });
  }

  getOnHomeNews() {
    this.schemaType = SCHEMA_TYPE.ARTICLE;
    this.articleType = NATIONAL_PAGES.NEWS;
    this.schoolApiService
      .getSchoolArticles({
        domainType: this.domainType,
        schemaType: this.schemaType,
        filter: { articleType: this.articleType, isShownOnHome: 'true' },
        isArchived: false,
        language: this.language,
        start: 0,
        limit: 5,
      })
      .subscribe((data: IResponse<IList<ISchoolArticle>>) => {
        if (data.status) {
          this.newsCarousel = this.mapArticles(data.payload?.list || []);
          this.cdr.detectChanges();
        }
      });
  }

  getTestimonials() {
    this.schemaType = SCHEMA_TYPE.GENERAL;
    this.articleType = NATIONAL_PAGES.HOME.TESTIMONIAL;
    this.schoolApiService
      .getSchoolArticles({
        domainType: this.domainType,
        schemaType: this.schemaType,
        filter: { articleType: this.articleType },
        isArchived: false,
        language: this.language,
        start: this.start,
        limit: this.limit,
      })
      .subscribe((data: IResponse<IList<ISchoolArticle>>) => {
        if (data.status) {
          this.totalcount = data.payload?.count || 0;
          this.testimonialData = this.mapTestimonials(data.payload?.list || []);
          this.cdr.detectChanges();
        }
      });
  }

  getPhotoGallery() {
    this.schemaType = SCHEMA_TYPE.GENERAL;
    this.articleType = NATIONAL_PAGES.HOME.GALLERY;
    this.schoolApiService
      .getSchoolArticles({
        domainType: this.domainType,
        schemaType: this.schemaType,
        filter: { articleType: this.articleType },
        isArchived: false,
        language: this.language,
        start: 0,
        limit: Number.MAX_SAFE_INTEGER,
      })
      .subscribe((data: IResponse<IList<ISchoolArticle>>) => {
        if (data.status) {
          this.galleryData = this.mapPhotoGallery(data.payload?.list || []);
          this.cdr.detectChanges();
        }
      });
  }
}
